import { useHandleResponse } from '@/utils/useHandleResponse';
import { useMutation } from '@tanstack/react-query';
import { App, Button, Checkbox, Col, Divider, Form, Input, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateField, updateProps } from '../../../contextRedux/Labor/LaborModel';
import LaborService from '../../../services/labor/LaborService';
import { RootState } from '../../../store';
import useWindowSize from '../../../utils/useWindowSize';

const LaborForm: React.FC<any> = () => {
  const [form] = useForm();
  const { message } = App.useApp();
  const handleResponse = useHandleResponse();
  const dispatch = useDispatch();
  const width = useWindowSize();

  const labor = useSelector((state: RootState) => state.models.labor);

  const initialValues = {
    id: useSelector((state: RootState) => state?.models?.labor?.id),
    name: useSelector((state: RootState) => state?.models?.labor?.name),
    isActive: useSelector((state: RootState) => state?.models?.labor?.isActive),
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fieldsValue = {
      ...form.getFieldsValue(true),
      isActive: e.target.checked,
    };
    form.setFieldsValue(fieldsValue);
  };

  const onSaveLaborType = async () => {
    saveLaborType(labor);
  };

  const { mutate: saveLaborType, isPending: _isSavingLabor } = useMutation({
    mutationFn: (formData: any) => LaborService.upsert(labor.id, formData),
    onSuccess: (data: any) => {
      if (data) {
        handleResponse(data, data?.response?.name);
        dispatch(updateProps({ field: 'isModalVisible', value: false }));
        dispatch(updateProps({ field: 'refresh', value: !labor.props.refresh }));
      }
    },
    onError: (error: any) => {
      message.error(error.message);
    },
  });

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  useEffect(() => {
    form.setFieldsValue(labor);
  }, [labor]);

  return (
    <Form
      form={form}
      name='laborForm'
      initialValues={initialValues}
      onValuesChange={handleFieldChange}
      onFinish={onSaveLaborType}
      layout='vertical'
    >
      <Divider />
      <Row gutter={[16, 16]} className='row'>
        <Col xs={24} sm={12} md={8} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Denumire' name='name' rules={[{ required: true, message: 'Introdu denumire!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Status' name='isActive' valuePropName='checked'>
            <Checkbox onChange={() => handleCheckboxChange} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button type='primary' htmlType='submit'>
          Finalizare
        </Button>
      </Form.Item>
    </Form>
  );
};

export default LaborForm;
